// Common
import { Modal } from "bootstrap";

// Common
import { default as init } from "./common/base";

// Helpers
import { Component } from "./helpers/component";

// Components
import { Slider } from "../../components/slider/slider";
import { Share } from "../../components/share/share";
import { Menu } from "../../components/menu/menu";

//import { Header } from "../../components/header/header";
import Swiper from "swiper";

// Registering components
//Component.register("Header", Header);
Component.register("Slider", Slider);
Component.register("Share", Share);
Component.register("Menu", Menu);

init();

document.addEventListener('DOMContentLoaded', () => {

//ScrollTop ancore

$('a[href="#Prenota"]').click(function(){
    // event.preventDefault();
    var offset = $('#Prenota').offset();
    var scrollto = offset.top;
    $('html, body').animate({scrollTop:scrollto}, 1000);
});
    $('[data-fancybox="gallery"]').fancybox({
      openEffect  : 'fade',
      closeEffect : 'fade',
      helpers: {
          title : {
              type : 'inside'
          },
          overlay: {
              locked: false // Elimina il problema dell scroll verso il top all'apertura
          },
          media : {
          }
      }
  });


});
